import { notification } from 'antd'
import CommonApi from './Apiservices/CommonAPI'

/*eslint-disable*/
export default create

export async function create(payload) {
  const state = {
    res: false
  }
  await CommonApi.SaveData('/api/v1/admin/mailing/list/type/create', payload)
    .then((response) => {
      notification.success({
        message: response.data.message,
      });
      state.res = true
      return state

    }).catch(error => {
      notification.warning({
        message: error.message,
      });
    })
  return state
}

export function Edit(name, description, id) {
  const state = {
    res: false
  }
  const body =
  {
    description: description,
    name: name,
  }
  CommonApi.SaveData(`​/api/v1/admin/mailing/list/type/update/${id}`, body)
    .then((response) => {
      notification.success({
        message: response.data.message,
      });
      state.res = true
      return state

    }).catch(error => {
      notification.warning({
        message: error.message,
      });
    })
  return state

}
